// How wet the ground is, 0 dry to 1 soaked, from how long it has been raining. Rain wets the
// streets in about a minute; they take ten to dry once it stops. Materials read `level` each frame.
export class Wetness {
  constructor(forced = null) {
    this.level = forced === null ? 0 : forced;
    this.forced = forced;
  }

  update(dt, rain) {
    if (this.forced !== null) return this.level;
    if (rain > 0.08) this.level = Math.min(1, this.level + (dt / 60) * Math.min(1, rain * 2));
    else this.level = Math.max(0, this.level - dt / 600);
    return this.level;
  }
}

const mix = (a, b, t) => a + (b - a) * t;

// Applies a wetness level to the ground materials: wet tar goes dark and shiny, earth turns to
// mud, zinc roofs gleam, plaster darkens a little. `set` is { tar, earth, roofs, walls } Phong or
// Lambert materials shared by every tile; `setGroundTint` darkens the per-tile ground.
export function applyWetness(level, set, setGroundTint) {
  if (level === set.appliedWet) return;
  set.appliedWet = level;
  const tar = set.tar;
  tar.color.setScalar(mix(1, 0.42, level));
  tar.specular.setScalar(mix(0.03, 0.42, level));
  tar.shininess = mix(8, 90, level);
  const earth = set.earth;
  earth.color.setScalar(mix(1, 0.55, level));
  earth.specular.setScalar(mix(0.0, 0.14, level));
  earth.shininess = mix(5, 30, level);
  const roofs = set.roofs;
  roofs.specular.setScalar(mix(0.1, 0.35, level));
  roofs.shininess = mix(18, 60, level);
  set.walls.color.setScalar(mix(1, 0.86, level));
  setGroundTint(mix(1, 0.62, level));
}
